/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Plant_Grow_TitleInputs */

const en_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay focused and your seedling starts to grow.`)
};

const ar_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حافظ على تركيزك وستبدأ شتلتك فى النمو`)
};

const de_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleiben Sie konzentriert, und Ihr Setzling beginnt zu wachsen.`)
};

const es_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concéntrate y tus semillas empezarán a crecer.`)
};

const fr_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restez concentré et votre jeune pousse commencera à grandir.`)
};

const it_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimani concentrato e la tua piantina inizierà a crescere.`)
};

const ja_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中し続けると、苗が育ち始めます`)
};

const ko_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중하면 묘목이 자라기 시작해요.`)
};

const pt_br_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha o foco e sua muda começa a crescer.`)
};

const ru_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжайте фокусироваться, и ваш саженец начнет расти.`)
};

const th_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสให้ต่อเนื่อง แล้วต้นกล้าจะเริ่มงอกงาม`)
};

const tr_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmaya devam et ki fidanın büyümeye başlasın.`)
};

const zh_cn_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你专注的同时，树苗会逐渐成长…`)
};

const zh_tw_walkturough_plant_grow_title = /** @type {(inputs: Walkturough_Plant_Grow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你專注的同時，樹苗會逐漸成長…`)
};

/**
* | output |
* | --- |
* | "Stay focused and your seedling starts to grow." |
*
* @param {Walkturough_Plant_Grow_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_plant_grow_title = /** @type {((inputs?: Walkturough_Plant_Grow_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Plant_Grow_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_plant_grow_title(inputs)
	if (locale === "ar") return ar_walkturough_plant_grow_title(inputs)
	if (locale === "de") return de_walkturough_plant_grow_title(inputs)
	if (locale === "es") return es_walkturough_plant_grow_title(inputs)
	if (locale === "fr") return fr_walkturough_plant_grow_title(inputs)
	if (locale === "it") return it_walkturough_plant_grow_title(inputs)
	if (locale === "ja") return ja_walkturough_plant_grow_title(inputs)
	if (locale === "ko") return ko_walkturough_plant_grow_title(inputs)
	if (locale === "pt_br") return pt_br_walkturough_plant_grow_title(inputs)
	if (locale === "ru") return ru_walkturough_plant_grow_title(inputs)
	if (locale === "th") return th_walkturough_plant_grow_title(inputs)
	if (locale === "tr") return tr_walkturough_plant_grow_title(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_plant_grow_title(inputs)
	return zh_tw_walkturough_plant_grow_title(inputs)
});